module.exports = __webpack_public_path__ + "static/media/Check.98ea99ce.svg";